var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('import-excel',{ref:"excel-data",attrs:{"label":_vm.label},on:{"fileIsReady":_vm.fileIsReady}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }